//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StockKittingToolNotAllowedIcon',
  props: {
    manager: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'tool' // tool, stock
    }
  },
  computed: {
    message: function () {
      const typeName = this.type === 'tool' ? 'Материал' : 'Склад'
      return typeName + ' не входит в список разрешенных для склада-получателя'
    }
  },
  methods: {
    onClick: function () {
      this.$d_ask({
        header: 'Внимание!',
        warning: this.message,
        buttons: [
          { key: 'cancel', name: 'Понятно', color: 'green' }
        ]
      })
    }
  }
}
